<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.projectId"
    :getMethod="getProject" :refreshOnTimestamp="true" :notificationListeners="[srEventKey]"
    :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewProjectContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.Project
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.projectId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.ProjectChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>